/**
 * Native Shopify Predictive Search — replaces the prototype's client-side
 * array filter with the real /search/suggest.json endpoint.
 */
(function () {
  "use strict";

  var routes = (window.Pawello && window.Pawello.routes) || {};
  var strings = (window.Pawello && window.Pawello.strings) || {};

  document.addEventListener("DOMContentLoaded", function () {
    var input = document.querySelector("[data-search-input]");
    var results = document.querySelector("[data-search-results]");
    if (!input || !results) return;

    var timer = null;

    function render(query, products) {
      if (!query) {
        results.innerHTML = '<p class="search-empty">' + strings.searchTypeToSearch + "</p>";
        return;
      }
      if (!products.length) {
        results.innerHTML = '<p class="search-empty">' + strings.searchNoResultsHtml.replace("{{ terms }}", query) + "</p>";
        return;
      }
      var html = products
        .slice(0, 6)
        .map(function (p) {
          var image = p.featured_image ? p.featured_image.url : p.image;
          return (
            '<a href="' +
            p.url +
            '" class="search-result">' +
            '<div class="search-result__image">' +
            (image ? '<img src="' + image + '" loading="lazy" alt="">' : "") +
            "</div>" +
            '<div style="flex:1;min-width:0;">' +
            '<p style="font-size:0.875rem;font-weight:500;">' +
            p.title +
            "</p>" +
            '<p style="font-size:0.75rem;color:var(--color-secondary);">' +
            p.price +
            "</p>" +
            "</div>" +
            "</a>"
          );
        })
        .join("");
      results.innerHTML = html;
    }

    function search(query) {
      if (!query) {
        render("", []);
        return;
      }
      var url = (routes.predictiveSearchUrl || "/search/suggest.json") + "?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,vendor";
      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(query, products);
        })
        .catch(function () {
          render(query, []);
        });
    }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        search(q);
      }, 200);
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && input.value.trim()) {
        window.location.href = (routes.searchUrl || "/search") + "?q=" + encodeURIComponent(input.value.trim()) + "&type=product";
      }
    });
  });
})();
